<section class="bg-gray-50 dark:bg-gray-900 py-3 sm:py-5">
  <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 space-y-6">
    
    <!-- PRIMERA SECCIÓN: Gestión de Códigos -->
    <div class="relative overflow-hidden bg-white shadow-md dark:bg-gray-800 sm:rounded-lg">
      <div class="px-4 divide-y dark:divide-gray-700">
        <div class="flex items-center justify-between py-4">
          <h2 class="text-xl font-bold text-gray-900 dark:text-white">
            <i class="fas fa-code mr-2"></i>
            Etiquetas
          </h2>
        </div>

        <!-- Action buttons -->
        <div class="flex flex-col items-start justify-between py-4 space-y-3 md:flex-row md:items-center md:space-y-0">
          <!-- Contenedor izquierdo con buscador y filtros -->
          <div class="flex flex-col space-y-3 md:flex-row md:space-y-0 md:space-x-4">
            <!-- Buscador de etiquetas -->
            <div class="w-full md:w-80">
              <div class="relative">
                <input 
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="filterCodes()"
                  type="text" 
                  id="searchCodes"
                  placeholder="Buscar etiquetas por código, nombre..."
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3">
                  <i class="fas fa-search text-gray-400"></i>
                </div>
              </div>
            </div>
            
            <!-- Filtros -->
            <div class="flex flex-col space-y-2 md:flex-row md:space-y-0 md:space-x-4">
              <div class="flex items-center space-x-2">
                <label for="categoryFilter" class="text-sm font-medium text-gray-700 dark:text-gray-300">Filtrar por categoría:</label>
                <select [(ngModel)]="selectedCategoryFilter" (ngModelChange)="filterByCategory()" id="categoryFilter" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block py-1.5 pl-3 pr-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                  <option value="">Todas las categorías</option>
                  <option *ngFor="let category of categoryOptions" [value]="category.value">{{category.label}}</option>
                </select>
              </div>
              
              <div class="flex items-center space-x-2">
                <label for="statusFilter" class="text-sm font-medium text-gray-700 dark:text-gray-300">Filtrar por estatus:</label>
                <select [(ngModel)]="selectedStatusFilter" (ngModelChange)="filterByCategory()" id="statusFilter" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block py-1.5 pl-3 pr-8 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                  <option value="">Todos los estatus</option>
                  <option value="true">Activo</option>
                  <option value="false">Inactivo</option>
                </select>
              </div>
            </div>
          </div>
          
          <!-- Botón Nueva etiqueta pegado a la derecha -->
          <div class="w-full md:w-auto flex justify-end md:ml-4">
            <button *ngIf="_auth.hasPermission('config.etiquetas.create')" (click)="toggleModal()" type="button" class="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 shadow-md">
              <i class="fas fa-plus mr-2"></i>
              <span class="font-bold">Nueva etiqueta</span>
            </button>
          </div>
        </div>

        <!-- Modal para crear código -->
        <div
        *ngIf="isModalOpen"
        class="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
        <div class="relative p-4 w-full max-w-2xl">
          <div class="relative bg-white rounded-lg shadow dark:bg-gray-800">
            <!-- Encabezado del modal -->
            <div class="flex justify-between items-center p-4 border-b dark:border-gray-600">
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                Crear una etiqueta
              </h3>
              <button
                (click)="toggleModal()"
                class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-1.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                </svg>
              </button>
            </div>

            <form class="p-4" (ngSubmit)="serviceCode()">
              <div class="grid gap-4 sm:grid-cols-2">
                <div>
                  <label for="code" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Código<span class="text-red-500">*</span></label>
                  <input [(ngModel)]="newCode.code" type="text" name="code" id="code" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Ejem. MT-EMP-ADMIN">
                  <span class="text-red-500 text-sm" *ngIf="!newCode.code.trim() && globalError">Código requerido</span>
                </div>
                <div>
                  <label for="name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nombre del código<span class="text-red-500">*</span></label>
                  <input [(ngModel)]="newCode.name" type="text" name="name" id="name" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Ejem. Código de administradores">
                  <span class="text-red-500 text-sm" *ngIf="!newCode.name.trim() && globalError">Nombre del código requerido</span>
                </div>
                
                <div class="sm:col-span-2">
                  <label for="category" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Categoría<span class="text-red-500">*</span></label>
                  <select [(ngModel)]="newCode.category" name="category" id="category" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
                    <option value="" disabled selected>Selecciona una categoría</option>
                    <option *ngFor="let category of categoryOptions" [value]="category.value">{{category.label}}</option>
                  </select>
                  <span class="text-red-500 text-sm" *ngIf="!newCode.category && globalError">Categoría requerida</span>
                </div>

                <div class="sm:col-span-2">
                  <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Descripción</label>
                  <textarea [(ngModel)]="newCode.description" type="text" name="description" id="description" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 h-44" placeholder="Ejem. Este es un código para los empleados administradores"></textarea>
                </div>
              </div>
              <div class="flex items-center space-x-4 mt-4">
                <button type="submit" class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 w-[100%]">
                  Agregar etiqueta
                </button>
              </div>
            </form>
          </div>
        </div>
        </div>
      </div>

      <!-- Table -->
      <div class="overflow-x-auto">
        <!-- Loading State -->
        <div *ngIf="loadingCodes" class="flex justify-center items-center py-12">
          <div class="text-center">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
            <p class="text-gray-600 mt-4">Cargando etiquetas...</p>
          </div>
        </div>

        <!-- Table Content -->
        <div *ngIf="!loadingCodes">
        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 mb-3">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" class="px-4 py-3">Código</th>
              <th scope="col" class="px-4 py-3">Estatus</th>
              <th scope="col" class="px-4 py-3">Categoría</th>
              <th scope="col" class="px-4 py-3">Planes</th>
              <th scope="col" class="px-4 py-3">Persona</th>
              <th scope="col" class="px-4 py-3">Nombre</th>
              <th scope="col" class="px-4 py-3">Creado</th>
              <th scope="col" class="pr-32">Usuario</th>
              <th scope="col" class="px-4 py-3">Acción</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of filteredCodesList">
            <tr class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700">
              <th scope="row" class="px-4 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                <span class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">{{item?.code}}</span>
              </th>
              <td class="px-4 py-2">
                <div class="flex items-center">
                  <div class="w-3 h-3 mr-2" [ngClass]="item?.status ? 'bg-green-500 rounded-full' : 'bg-red-500 rounded-full'"></div>
                  <span class="font-medium text-gray-900 dark:text-white">
                    {{item?.status ? 'Activo' : 'Inactivo'}}
                  </span>
                </div>
              </td>
              <td class="px-4 py-2">
                <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                  {{getCategoryLabel(item?.category) || 'Sin categoría'}}
                </span>
              </td>
              <td class="pl-10">
                <span>{{item.planCode || 0}}</span>
              </td>
              <td class="pl-10">
                <span>{{item?.personCode || 0}}</span>
              </td>
              <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                <span>{{item?.name}}</span>
              </td>
              <td class="px-4 pyt-2">{{item?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</td>
              <td>
                <span>{{item?.user?.name}}</span>
                <span> {{item?.user?.lastName}}</span>
              </td>
              <td>
                <button *ngIf="_auth.hasPermission('config.etiquetas.update')" class="w-5 h-5 ml-5" (click)="updateStatus(item?.code, item?.status)">
                  <i *ngIf="item?.status" class="fas fa-lock-open text-gray-500"></i>
                  <i *ngIf="!item?.status"  class="fas fa-lock text-red-500"></i>
                </button>
                <button class="ml-5 bg-red-600 w-5 h-5 rounded-md" (click)="deleteCodeDynamic(item?.code)" *ngIf="(item?.personCode || 0) < 1 && (item?.planCode || 0) < 1 && _auth.hasPermission('config.etiquetas.delete')">
                  <i class="fas fa-trash-alt text-white"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
          <span class="text-black pl-10" *ngIf="filteredCodesList.length === 0 && !loadingCodes">No se encontraron códigos creados</span>
        </div>
      </div>

      <!-- Navigation -->
      <nav class="flex flex-col items-start justify-between p-4 space-y-3 sm:flex-row sm:items-center sm:space-y-0" aria-label="Table navigation">
        <div class="flex items-center space-x-3">
          <label for="rows" class="text-xs font-normal text-gray-500 dark:text-gray-400">Rows per page</label>
          <select id="rows" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block py-1.5 pl-3.5 pr-6 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
            <option selected value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <div class="text-xs font-normal text-gray-500 dark:text-gray-400">
            <span class="font-semibold text-gray-900 dark:text-white">1-10</span>
            of
            <span class="font-semibold text-gray-900 dark:text-white">100</span>
          </div>
        </div>
      </nav>
    </div>

    <!-- SEGUNDA SECCIÓN: Asignación de Métodos de Pago -->
    <div class="relative overflow-hidden bg-white shadow-md dark:bg-gray-800 sm:rounded-lg">
      <div class="px-4 divide-y dark:divide-gray-700">
        <div class="flex items-center justify-between py-4">
          <h2 class="text-xl font-bold text-gray-900 dark:text-white">
            <i class="fas fa-credit-card mr-2"></i>
            Asignación de Métodos de Pago
          </h2>
        </div>

        <!-- Header con selector de código -->
        <div class="py-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Selector de código bancario -->
            <div>
              <label for="bankCodeSelect" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Etiqueta (Categoría: Medios de pago)
              </label>
              <select 
                [(ngModel)]="selectedBankCode" 
                (ngModelChange)="onBankCodeSelect()"
                id="bankCodeSelect" 
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                <option value="" disabled selected>Selecciona una etiqueta</option>
                <option *ngFor="let code of bankAccountCodes" [ngValue]="code">
                  {{code.code}} - {{code.name}}
                </option>
                <option *ngIf="bankAccountCodes.length === 0" value="" disabled>
                  No hay códigos de "Medios de pago" disponibles
                </option>
              </select>
              <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Solo se muestran códigos activos de la categoría "Medios de pago"
              </p>
              <div *ngIf="bankAccountCodes.length === 0" class="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p class="text-xs text-yellow-700">
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  No hay etiquetas de "Medios de pago" activas. Crea una en la sección superior.
                </p>
              </div>
            </div>

            <!-- Input de búsqueda de métodos de pago -->
            <div>
              <label for="paymentSearch" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Buscar Método de Pago
              </label>
              <div class="relative">
                <input 
                  [(ngModel)]="searchPaymentMethod"
                  (ngModelChange)="filterPaymentMethods()"
                  [disabled]="!selectedBankCode"
                  type="text" 
                  id="paymentSearch"
                  placeholder="Buscar método, banco, número..."
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3">
                  <i class="fas fa-search text-gray-400"></i>
                </div>
              </div>
              <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Selecciona primero una etiqueta
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Contenido principal -->
      <div class="p-4">
        <!-- Mensaje cuando no hay código seleccionado -->
        <div *ngIf="!selectedBankCode" class="text-center py-12">
          <i class="fas fa-info-circle text-4xl text-gray-400 mb-4"></i>
          <p class="text-gray-500 dark:text-gray-400">Selecciona una etiqueta de "Medios de pago" para comenzar</p>
          <p class="text-sm text-gray-400 dark:text-gray-500 mt-2">Los códigos disponibles se toman de la tabla superior</p>
        </div>

        <!-- Spinner de carga -->
        <div *ngIf="loadingPaymentMethods" class="flex items-center justify-center py-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span class="ml-3 text-gray-600 dark:text-gray-400">Cargando métodos de pago...</span>
        </div>

        <!-- Resultados de búsqueda -->
        <div *ngIf="selectedBankCode && !loadingPaymentMethods" class="mb-6">
          <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-3">
            Métodos de Pago Disponibles
            <span *ngIf="searchPaymentMethod" class="text-sm font-normal text-gray-500">(filtrados)</span>
          </h3>
          
          <!-- Mensaje cuando no hay métodos de pago -->
          <div *ngIf="filteredPaymentMethods.length === 0 && paymentMethods.length === 0" class="text-center py-8">
            <i class="fas fa-credit-card text-4xl text-gray-400 mb-4"></i>
            <p class="text-gray-500 dark:text-gray-400">No hay métodos de pago disponibles</p>
          </div>
          
          <!-- Mensaje cuando no hay resultados de búsqueda -->
          <div *ngIf="filteredPaymentMethods.length === 0 && paymentMethods.length > 0" class="text-center py-8">
            <i class="fas fa-search text-4xl text-gray-400 mb-4"></i>
            <p class="text-gray-500 dark:text-gray-400">No se encontraron métodos de pago con ese criterio</p>
            <p class="text-sm text-gray-400 dark:text-gray-500 mt-2">Intenta con otros términos de búsqueda</p>
          </div>
          
          <!-- Lista de métodos de pago -->
          <div *ngIf="filteredPaymentMethods.length > 0" class="grid gap-3 max-h-80 overflow-y-auto">
            <div 
              *ngFor="let method of filteredPaymentMethods" 
              (click)="addPaymentMethod(method)"
              class="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors dark:border-gray-600 dark:hover:bg-gray-700">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <div class="flex items-center space-x-3 mb-2">
                    <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                      {{method.payment_method?.name}}
                    </span>
                    <span class="text-sm font-medium text-gray-900 dark:text-white">
                      {{method.bank?.name || 'Sin banco'}}
                    </span>
                    <span class="bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded dark:bg-gray-600 dark:text-gray-300">
                      {{method.currency?.name}}
                    </span>
                  </div>
                  <div class="text-sm text-gray-500 dark:text-gray-400">
                    <span *ngIf="method.number">Número: {{method.number}}</span>
                    <span *ngIf="method.phone">Teléfono: {{method.phone}}</span>
                    <span *ngIf="method.email">Email: {{method.email}}</span>
                  </div>
                </div>
                <div class="flex items-center text-blue-600 dark:text-blue-400">
                  <i class="fas fa-plus mr-2"></i>
                  <span class="text-sm">Agregar</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Lista de métodos seleccionados -->
        <div *ngIf="selectedPaymentMethods.length > 0" class="mb-6">
          <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-3">
            Métodos de Pago Seleccionados ({{selectedPaymentMethods.length}})
          </h3>
          <div class="grid gap-3">
            <div 
              *ngFor="let method of selectedPaymentMethods" 
              class="p-4 border border-green-200 bg-green-50 rounded-lg dark:border-green-600 dark:bg-green-900/20">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <div class="flex items-center space-x-3 mb-2">
                    <span class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                      {{method.payment_method?.name}}
                    </span>
                    <span class="text-sm font-medium text-gray-900 dark:text-white">
                      {{method.bank?.name || 'Sin banco'}}
                    </span>
                    <span class="bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded dark:bg-gray-600 dark:text-gray-300">
                      {{method.currency?.name}}
                    </span>
                  </div>
                  <div class="text-sm text-gray-600 dark:text-gray-300">
                    <span *ngIf="method.number">{{method.number}}</span>
                    <span *ngIf="method.phone">{{method.phone}}</span>
                    <span *ngIf="method.email">{{method.email}}</span>
                  </div>
                </div>
                <button 
                  (click)="removePaymentMethod(method)"
                  class="text-red-600 hover:text-red-800 p-2 hover:bg-red-100 rounded-full transition-colors dark:text-red-400 dark:hover:text-red-300 dark:hover:bg-red-900/20">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Botón de guardar -->
        <div *ngIf="selectedBankCode" class="flex justify-end">
          <button 
            (click)="saveAssignments()"
            [disabled]="selectedPaymentMethods.length === 0 || saving"
            class="px-6 py-3 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 flex items-center">
            <i *ngIf="saving" class="fas fa-spinner fa-spin mr-2"></i>
            <i *ngIf="!saving" class="fas fa-save mr-2"></i>
            {{saving ? 'Guardando...' : 'Guardar Asignaciones'}}
          </button>
        </div>
      </div>
    </div>

  </div>
</section>
